import React from 'react';
import moment from 'moment';
import { TableCell, Popup } from 'semantic-ui-react';
import { FiCheckCircle } from 'react-icons/fi';
import { AppState } from 'services/types';
import {
    SprayEventStartDate,
    SprayEventEntityId
} from 'services/sprayEvents/types';
import { useSelector } from 'react-redux';
import { makeSelectEntityHasBeenSprayedAlready } from './selectors';

export interface Props {
    startDate?: SprayEventStartDate;
    entityId: SprayEventEntityId;
}

export default function EntityTableRowSprayedStatusCell(
    props: Props
): React.ReactElement {
    const { startDate } = props;

    const sprayedAlready = useSelector((state: AppState) =>
        makeSelectEntityHasBeenSprayedAlready()(state, props)
    );

    return (
        <TableCell textAlign="left" className="events-table-cell-padding">
            {sprayedAlready && (
                <Popup
                    trigger={
                        <FiCheckCircle
                            size={22}
                            className="text green"
                            style={{ verticalAlign: 'middle' }}
                        />
                    }
                    content={`Already sprayed at ${moment(
                        startDate,
                        'YYYY-MM-DD'
                    ).format('DD/MM/YYYY')}`}
                    inverted
                    basic
                    position="top center"
                />
            )}
        </TableCell>
    );
}
